import * as React from 'react';

import { PlaidLinkButton } from '@rematter/modules/finance/_components/_shared/PlaidLinkButton';
import { Button } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';
import { LucidePlusCircle } from 'lucide-react';

import * as state from '../../_state/financialAccounts.state';

import { useTranslations } from '@/finance/i18n/useTranslations';

type FinancialAccountListActionsProps = {
  onPlaidSuccess: () => void;
};

//
// ⚛️ ⚛️ ⚛️ FINANCIAL ACCOUNT LIST ACTIONS ⚛️ ⚛️ ⚛️
//
export const FinancialAccountListActions = ({
  onPlaidSuccess,
}: FinancialAccountListActionsProps) => {
  const t = useTranslations();

  // Atoms
  const { isPending: syncLinkedAccountsIsLoading } = useAtomValue(
    state.$syncAccountTransactions,
  );
  const setEditingAccount = useSetAtom(state.$editingAccount);
  const setIsEditDialogOpen = useSetAtom(state.$isEditDialogOpen);
  const syncLinkedAccounts = useSetAtom(state.$syncAccountTransactions);

  // Callbacks
  const handleCreateAccount = React.useCallback(() => {
    setEditingAccount(undefined);
    setIsEditDialogOpen(true);
  }, [setEditingAccount, setIsEditDialogOpen]);
  const handleSyncTransactions = React.useCallback(async () => {
    await syncLinkedAccounts();
  }, [syncLinkedAccounts]);

  return (
    <>
      <Button
        icon={<LucidePlusCircle />}
        onPress={handleCreateAccount}
        variant="solid"
        color="primary"
      >
        {t.financialAccounts.list.buttons.newAccount}
      </Button>
      <PlaidLinkButton
        onSuccess={onPlaidSuccess}
        pending={syncLinkedAccountsIsLoading}
      />
      <Button
        onPress={handleSyncTransactions}
        isDisabled={syncLinkedAccountsIsLoading}
        variant="outline"
      >
        {t.financialAccounts.list.buttons.syncTransactions}
      </Button>
    </>
  );
};
